import React from 'react';

import { H3, P2 } from '@repo/ui-kit/components/core/Typography';

import { Bar } from '../Bar/Bar';
import { durationMs } from '../config';
import { StepProps } from '../types';

import { BarWrapper, StepContainer } from './styles';

export const Step: React.FC<StepProps> = ({
  title,
  description,
  isActive,
  setActive,
  darkMode,
}) => {
  return (
    <StepContainer
      darkMode={darkMode}
      isActive={isActive}
      onClick={() => !isActive && setActive()}
    >
      <BarWrapper isActive={isActive}>
        <Bar durationMs={durationMs} />
      </BarWrapper>
      <H3 bold color="inherit">
        {title}
      </H3>
      <P2 color="inherit">{description}</P2>
    </StepContainer>
  );
};
